export const ZhTW = {
  zhTW:{
    companyName: "KopaPro",
    langDesc: "正體中文",  
    en:"English", 
    zhTW:"繁",
    zhCN:"简",
    goodDay:"您好",
    home: "首頁",
    kopapro:"KopaPro",
    addNewShop:"添加 KopaPro",
    addNewDomain: "購買新網域",
    refresh:"刷新",
    refreshFail:"刷新失敗，請重試。",
    kopaproLicenses:"KopaPro 訂閱",
    extend:"續約",
    change:"更改",
    renew: "重啟",
    history:"歷史紀錄",
    subscriptionHistory:"訂閱歷史紀錄",
    back:"後退",
    assign: "分配",
    sessionExpired:"頁面已過期，請重新登錄。",
    addNewMerchant:"添加新商戶",
    pleaseWait:"請稍等",   
    loading:"載入中...", 
    needTrial:"需要免費試用嗎?",
    subDirectly:"你亦能填寫以下表格直接訂閱",
    curd:{
      save:'保存',
      saveFail:'保存失敗，請重試。',
      getFail:'獲取資料失敗，請重試。',
      saveSuccess:'保存成功！'
    },
    kopaproLicense:{ 
      details:"詳細",    
      client:"客戶",   
      code:"KopaPro編號",
      codeHelperText:"獨一無二的子網域",
      desc: "店名",
      descHelperText:"商店名稱",
      sysAdmin:"系統管理",
      rebranch:"重新初始化",
      rebranchKey:"重新初始化密碼",
      plan:{
        plan:"方案",
        oriPlan:"目前方案",
        su: "基本",
        bu: "進階",
        pm: "高階",
        et: "企業旗艦"
      },
      support:{
        support:"支援",
        oriSupport:"目前支援",
        noHotline:"電子郵件 / Whatsapp",
        hotline:"電子郵件, Whatsapp 及 熱線"
      },
      period:"期數",
      extendPeriod:"續約期數",
      years:"年",
      months:"月",
      currency:{
        currency:"貨幣",
        hkd:"港幣",
        usd:"美元",
        sgd:"新加坡元",
        rmb:"人民幣"
      },
      amt:"金額",
      couponCode:"優惠券碼",
      discount:"優惠",
      netAmt:"淨金額",
      expiryDate:"失效日期",
      newExpiryDate:"新失效日期",
      activationCode:"啟動碼 (M18 ERP 整合)",
      status:"狀態",
      serverStatus:"伺服器",
      createRemindMessage: '在選擇付款方式後，你所偏好的KopaPro編號({0})會暫時保留，請在{1}分鐘內完成付款程序。',
      paymentReason:{
        KPPPAY_EXTEND_SUBSCRIPTION:"KopaPro訂閱續約",
        KPPPAY_UPDATE_PLANSUPPORT:"更改KopaPro訂閱方案",
        KPPPAY_UPDATE_PLANSUPPORT_SU:"更改KopaPro計畫為基本版",
        KPPPAY_UPDATE_PLANSUPPORT_BU:"更改KopaPro計畫為進階版",
        KPPPAY_UPDATE_PLANSUPPORT_PM:"更改KopaPro計畫為高階版",
        KPPPAY_UPDATE_PLANSUPPORT_ET:"更改KopaPro計畫為企業旗艦版",
        KPP_NEW_SUB:"訂閱KopaPro",
        KPP_NEW_SUB_TRIAL:"免費試用",
        KPPPAY_UPDATE_SUPPORT_NOHOTLINE:'更改KopaPro支援為電子郵件 / Whatsapp',
        KPPPAY_UPDATE_SUPPORT_HOTLINE:'更改KopaPro支援為電子郵件, Whatsapp 及 熱線',
        KPPPAY_UPDATE_MONTH:'更改KopaPro期數為',
        KPPPAY_UPDATE_YEAR:'更改KopaPro期數為',
        KPPPAY_UPDATE_CUR_HKD:'更改KopaPro訂閱貨幣為港幣',
        KPPPAY_UPDATE_CUR_USD:'更改KopaPro訂閱貨幣為美元',
        KPPPAY_UPDATE_CUR_RMB:'更改KopaPro訂閱貨幣為人民幣',
        KPP_TRIAL_EXTEND:'KopaPro延長免費試用期'
      },
      residue:"方案餘額",
      invalidRefCode: '優惠碼無效',
      visit:"修改 eShop",
      payAndSubscribe:"訂閱 & 支付",
      payAndExtend:"續期 & 支付",
      paid:"已支付",
      pending:"處理中",
      cancelled:"已取消",
      active:"生效",
      expired:"失效",
      running:"運行中",
      terminated:"終止運行",
      ended:"終止運行",
      finished:"已完成",
      pay:"支付",
      createDate:"建立日期",
      date:"日期",
      extendTrial:"延長免費試用期14日",
      accessFail:"存取KopaPro時發生錯誤，請聯繫KopaPro客戶服務",
      invalidCode:"無法存取所選的KopaPro，請重新選擇",
      trialExpired:"你的免費試用已經完結",
      task:{
        Branch:"架設新伺服器",
        Migrate:"搬遷數據到新伺服器"
      },
      showServerTask:"檢視伺服器工作紀錄",
      planChange:"你的方案將由 #oPlan# 改變成 #nPlan#",
      planChangeWarn1:"當你付款後，系統會進行數據遷移",
      planChangeWarn2: "根據你的KopaPro使用量，遷移所花的時間有可能達數小時",
      planChangeWarn3: "確認改變，請輸入: " ,
      invalidPlanChange: "抱歉，KopaPro方案不能降級",
      refCode:"推廣優惠碼"                                                                          
    },
    dashboard: {
      title: "歡迎來到 KopaPro",
      missingInfo: {
        title: "完善你的帳戶資料",
        notCompletedMsg: "你的帳戶資料中尚有一些未填欄位，這樣可能會導致我們無法跟你取得聯絡。",
        notCompletedMsg2: "請到帳戶設定，並提供最新的基本資料及帳單資料。",
        action: "編輯帳戶"
      },
      addTrial:{
        title: "馬上試用",
        msg:"獲得30天免費試用",
        msg2: "無須信用卡,免費試用KopaPro",
        action1: "免費試用",
        action2: "馬上訂閱你試用的KopaPro",
        action3: "開始配置你的商店"
      },
      trialPeriod: {
        title: '試用期尚餘:',
        expireAt: "完結日期: "
      }
    },
    merchant:{
      basicInfo:"基本資訊",
      secondAuth:"二步驟驗證",
      billingInfo:"帳單資訊",
      merchant:"商戶",
      email:"電子郵件",        
      firstName:"名字",
      lastName:"姓氏",
      name: "姓名",
      companyName:"公司名稱",
      companyAddr:"公司地址",
      addr1:"地址第一行",
      addr2:"地址第二行",
      zipCode:"郵遞區號",
      city:"城市",
      province:"省份",
      country: "國家",                
      areaCode: "區號",
      mobile: "手機號碼",
      tel: "電話號碼",
      compTel:"公司電話",
      progCode:"程式編號",
      billingInfoHint: '請提供此帳戶的帳單資訊' ,
      basicInfoHint: '請提供此帳戶的基本資訊',
    },
    signUp:{
      title: "註冊",
      password:"密碼",
      confirmPw:"確認密碼",
      successInfo:"註冊成功",
      notMatchPassword: "與密碼不相同",
    },
    domains: {
      title: "網域",
      domainName: '網域名稱',
      createAt: '建立時間',
      expires: '失效日期',
      status: '狀態',
      renewAuto: '自動更新',
      mappedKopaPro: "映射到 KopaPro",
      renewDeadline: '更新最後期限',
      renewable: '可更新',
      ownerEmail:"網域持有人電郵地址 ",   
      companyName:"公司名稱",
      acceptAgreement: "我已閱讀並同意 {0} 的所有細節 ",
      acceptAgreementLinkText: "網域註冊協議",
      icannPrivacy:"ICANN 私隱條款",
      assignToKopapro: "分配 {0} 到 KopaPro",
      perYear: "/年",
      nextYearRenew:'下一次續費',
      perYearCharge:'每年: {0} {1}',
      domainContactLabel:'請提供此網域所需的信息',
      purchasePrivacy: " 購買 WHOIS 私隱保護",
      suggestion: "建議",
      otherSuggestion: "其他建議",
      available: '域名可被使用',
      notAvailable: '域名不可被使用',
      statuses: {
        InActive: "失效中",
        Active: "生效中",
        Suspended: "已停止",
        "Pending Delete Restorable": "等待刪除復原",
        Deleted: "已刪除",
        Archived: "Archived",
        "Pending Verification": "等待驗證",
        "Failed Verification": "驗證失敗",
        notAvailable: "不可使用",
        owned: "所有權歸您",
        taken: "已被註冊",
        notSupported: "不支持",
        processing: "處理中"
      },
      singleYear: "{0} 年",
      multiYears: "{0} 年",
      buyNew: {
        subTitle: "購買新網域",
        enterDomain: "輸入你有興趣的網域",
        selectDomain: "選擇網域",
        provideInfo: "提供資料",
        payment: "付款",
      },
      payment: {
        title: "訂單資訊",
        domainOwnerInfo: "網域所有者信息",
        whoisPrivacy: "WHOIS 私隱保護",
        whoisDetail: "當你啟動私隱保護服務時，我們會在公共註冊紀錄中以通用的聯絡資訊替換你的個人資訊，因此您的個人資訊不會被顯示在公共註冊紀錄。",
        privacy: "私隱&協議",
        agreementStatement: "請確認您已閱讀並同意 {0}及{1}。"
      },
      errors: {
        "invalid_shop_license_code": "無效的店鋪編號。",
        "invalid_tlds": "無效的頂層網域名。",
        "fetch_fail": "沒找到相關的功能變數名稱，請輸入其他關鍵字搜索。",
        invalidCharacters: "無效的字元。"
      },
      alerts: {
        expiry: {
          title: "網域失效提醒",
          message: "你的網域即將過期。請儘快處理以避免丟失網域。",
        },
        expired: {
          title: "網域失效提醒",
          message: "你的網域已經過期。請儘快處理以避免丟失網域。",
        },
        assignedDomain: {
          message: "你已分配 {0} 至 KopaPro - {1}. 發佈KopaPro後，網域便會立即生效。"
        }
      },
      contact: {
        englishOnly: "以下欄位必須以英文填寫"
      },
      delayRecords: "如果你剛才購買的網域仍未顯示在表中，請稍等並在幾秒後重新刷新。"
    },

    general: {
      errors: {
        required: "此欄位必須填入",
        maxLength: "不能多於 {0} 字元",
        minLength: "不能小於 {0} 字元",
        phone: "無效的電話號碼",
        email: "無效的電子郵件地址",
        currentPassword: "密碼不正確",
        notMatchPassword: "與新密碼不相同",
        requiredPassword: "如更改密碼，此欄位必須填入",
        englishOnly: "此欄位只能以英文字符填寫",
        alphanumericOnly: "此欄位只能以英文及數字字符填寫",
        alphanumericSymbolOnly: "此欄位只能以英文﹑數字字符及特定符號填寫(+-_&(),.:'`;/)",
        invalidEmailPassword: "電子郵件或密碼不正確"
      },
      email:"電子郵件",
      emailAddress:"電子郵件地址",   
      firstName:"名字",
      lastName:"姓氏",
      companyName:"公司名稱",
      phoneNumber: "電話號碼",
      addr1:"地址行1",
      addr2:"地址行2",
      postalCode:"郵政編碼",
      city:"城市",
      state: "州 / 省份",
      province: " 州 / 省份",
      country: "國家/地區",
      noRecord: "沒有紀錄",
      exampleShort: "例:",
      cancel: "取消",
      confirm: "確定",
      back: "返回",
      next: "下一步",
      pay: "支付",
      save: "保存",
      signUp: "註冊",
      signIn: "登入",
      select: "選擇",
      search: "搜尋",
      logout: "登出",
      total: '共',
      changePassword: "更改密碼",
      account: "帳戶",
      password:"密碼",
      currentPassword: "現有密碼",
      newPassword: "新密碼",
      confirmPassword: "重複新密碼",
      haveAccount: "已有帳戶？",
      noAccount:"沒有帳戶？",
      forgotPassword: "忘記密碼？",
      forgotPasswordTitle: "忘記您的密碼？",
      resetPasswordTitle: "重設密碼",
      returnToLogin: "返回登入",
      loginFailed: "電子郵件地址或密碼不正確",
      resetEmailSent:"已發送密碼重設郵件，請檢查你的電子郵箱。",
      resetSuccessFully:"密碼已更新。",
      resetPwEmail:"請提供你登入時的電子郵件地址。",
      hasPendingPayment:"你有待付款項",
      trialCheckEmail:"請檢查你的電郵信箱以獲取試用的帳號資訊",
      yes:"是",
      no:"否",
      verifyEmailTitle:"請認証你的電郵地址",
      verifyEmailMsg:"快將完成了!我們已傳送電郵到",
      verifyEmailMsg2:"只需點擊電郵內的連結即可完成註冊",
      verifyEmailMsg3:"如果你找不到, 試試查看垃圾郵件箱",
      verifyEmailMsg4:"還是找不到電郵嗎?",
      resendEmail:"重寄電郵",        
      backToSignUp:"返回登入",
      resendEmailOK:"成功重寄電郵",
      verifying:"請稍等認証中...",
      verifyOK:"成功認証",
      loginConsole:"登入KopaPro訂閱平台",
      reloginKppSite: "請重新登入你的KopaPro以刷新失效日期",
    },
    footer: {
      contact: "聯絡",
      tos: "服務協議",
      privacyPolicy: "私隱權政策",
    },
    account: {
      title: "帳戶資訊"
    },
    KppResponse:{
      DUPCODE: "重複的帳戶",
      DUPSHOP: "商店已存在",
      NOTFOUND: "找不到數據",
      VALIDFAIL: "錯誤的欄位",
      ILLEGAL_ALPHANUMERIC: "必須填寫數字或細楷字母",
      MAX_LENGTH:"超出欄位長度上限",
      INVALID_INPUT_FORMAT:"錯誤的輸入格式",
      TRIAL_CREATED:"你已申請過試用KopaPro",
      NO_DOWNGRADE:"方案不能降級",
      NO_DOWNPERIOD:"訂閱周期不能減少",
      LOWERCASE:"欄位只能填寫細楷英文"
    },
    countdown: {
      days: "日",
      hours: "小時",
      mins: "分鐘",
      secs: "秒",
    },
    payment: {
      title: "付款",
      instruction: "請掃描二維碼以完成付款。",
      selectMethod: "選擇付款方式",
        methods: {
          alipay: "支付寶",
          wechatPay: "微信支付",
          creditCard: "信用卡  / Apple Pay / Google Pay"
        }
    },
    wallet: {
      shortTitle: "MPCSB",
      title: '商戶預付送件服務結餘 (MPCSB)',
      overview: '總覽',
      statement: '賬單',
      transactions: 'Transactions',
      currentBalance: "當前結餘",
      openingBalance: "期初結餘",
      closingBalance: "期未結餘",
      costIn7Days: '最近7天的送件下單費用',
      costIn30Days: '最近30天的下單費用',
      recentDeposit: '最近存入',
      depositDialogTitle: '存入',
        recentTransactions: '最近交易',
        date: '日期',
        description: '描述',
        type: '交易種類',
        types: {
          deposit: '存入',
          expense: '扣款',
        },
        amount : '金額',
        actions: {
          deposit: '存入',
          enable:'啟動',
          accept: '同意及啟動',
          getStatement: '預覽賬單',
          exportStatement: '下載賬單(PDF)',
        },
        pending: '有待確認',
        walletStatement: 'MPCSB 賬單',
        statementDate: '賬單日期',
        topUp: '增值',
        use: '使用',
        dateTo: ' 至 ',
        balance: '結餘',
        depositLabel: '請輸入你想存入的金額:',
        enableDialogTitle: '啟動服務',
        askEnableLabel: '啟動以享用自動運單生成服務從而節省時間及減少錯誤。',
        currency: "貨幣",
        errors: {
          minAmount: "存入金額最少為 {0} {1}。",
          maxAmount: "存入金額最多為 {0} {1}。"
        },
        transactionDetails:{
          deposit: "存入至賬戶 ({0})",
          adjustment: "調整事項︰",
          reverseAdjustment: "反向調整事項︰",
        }


    }            
  }   
}
